import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
export default class ContentComplaintPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    app.setTitle('Жалоба на материал');
    this.loading = false;
    this.reference = null;
    this.form = {
      claimantRole: 'owner',
      fullName: '',
      organization: '',
      email: app.session.user?.email?.() || '',
      materialUrl: m.route.param('url') || '',
      rightsBasis: '',
      violationDescription: '',
      requestedAction: 'contact',
      authorityDetails: '',
      accuracyConfirmation: false,
      website: ''
    };
  }
  view() {
    return m('main.dc-complaint-page', {
      'aria-labelledby': 'dc-complaint-title'
    }, [m('header.dc-complaint-page__hero', m('.dc-complaint-container', [m('span', 'Защита прав'), m('h1#dc-complaint-title', 'Жалоба на материал'), m('p', 'Форма для правообладателя или его представителя. Обычное нарушение правил лучше отправить кнопкой «Пожаловаться» у сообщения.')])), m('.dc-complaint-container', this.reference ? this.success() : this.formView())]);
  }
  formView() {
    return m('form.dc-complaint-form', {
      onsubmit: event => this.submit(event)
    }, [m('.dc-complaint-form__notice', [m('strong', 'Перед отправкой'), m('p', 'Укажите конкретную ссылку и достаточно сведений для проверки. Не прикладывайте паспорт, банковские данные, пароли или закрытые ключи.')]), m('.dc-complaint-form__grid', [this.select('claimantRole', 'Статус заявителя', [['owner', 'Правообладатель'], ['representative', 'Представитель правообладателя']]), this.input('fullName', 'Имя заявителя', 'Иван Иванов или наименование ответственного лица', 'text', true), this.input('organization', 'Организация', 'Если обращение направляется от организации'), this.input('email', 'Email для ответа', 'name@example.ru', 'email', true)]), this.input('materialUrl', 'Ссылка на материал DevConnect', 'https://devconnect.ru/d/123-nazvanie', 'url', true), this.textarea('rightsBasis', 'Какие права вам принадлежат', 'Укажите произведение, авторство, лицензию или другое основание права.', true), this.textarea('violationDescription', 'Что именно нарушено', 'Назовите спорный фрагмент и объясните, почему публикация нарушает ваши права.', true), this.select('requestedAction', 'Ожидаемое действие', [['contact', 'Связаться со мной до принятия решения'], ['restrict', 'Ограничить доступ на время проверки'], ['remove', 'Удалить материал']]), this.form.claimantRole === 'representative' ? this.textarea('authorityDetails', 'Полномочия представителя', 'Опишите доверенность, договор или должность без паспортных данных.', true) : null, m('label.dc-complaint-confirmation', [m('input', {
      type: 'checkbox',
      required: true,
      checked: this.form.accuracyConfirmation,
      onchange: event => {
        this.form.accuracyConfirmation = event.target.checked;
      }
    }), m('span', ['Подтверждаю достоверность сведений и даю согласие на обработку данных обращения согласно ', m('a', {
      href: '/privacy',
      target: '_blank',
      rel: 'noopener'
    }, 'политике DevConnect'), '.'])]), m('label.dc-complaint-honeypot', {
      'aria-hidden': 'true'
    }, [m('span', 'Ваш сайт'), m('input', {
      type: 'text',
      tabindex: '-1',
      autocomplete: 'off',
      value: this.form.website,
      oninput: event => {
        this.form.website = event.target.value;
      }
    })]), m('button.Button.Button--primary.dc-complaint-submit', {
      type: 'submit',
      disabled: this.loading
    }, this.loading ? 'Отправляем…' : 'Отправить жалобу')]);
  }
  input(name, label, placeholder, type, required) {
    if (type === void 0) {
      type = 'text';
    }
    if (required === void 0) {
      required = false;
    }
    return m('label.dc-complaint-field', [m('span', label), m('input.FormControl', {
      type,
      required,
      placeholder,
      value: this.form[name],
      oninput: event => {
        this.form[name] = event.target.value;
      }
    })]);
  }
  textarea(name, label, placeholder, required) {
    if (required === void 0) {
      required = false;
    }
    return m('label.dc-complaint-field', [m('span', label), m('textarea.FormControl', {
      required,
      rows: 5,
      placeholder,
      value: this.form[name],
      oninput: event => {
        this.form[name] = event.target.value;
      }
    })]);
  }
  select(name, label, options) {
    return m('label.dc-complaint-field', [m('span', label), m('select.FormControl', {
      value: this.form[name],
      onchange: event => {
        this.form[name] = event.target.value;
      }
    }, options.map(_ref => {
      let [value, title] = _ref;
      return m('option', {
        value
      }, title);
    }))]);
  }
  submit(event) {
    event.preventDefault();
    if (this.loading) return;
    this.loading = true;
    app.request({
      method: 'POST',
      url: `${app.forum.attribute('apiUrl')}/devconnect/content-complaints`,
      body: this.form
    }).then(response => {
      this.reference = response.data.id;
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }).catch(error => {
      const message = error?.response?.errors?.[0]?.detail || 'Не удалось отправить жалобу. Проверьте поля и попробуйте ещё раз.';
      app.alerts.show({
        type: 'error'
      }, message);
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  success() {
    return m('.dc-complaint-success', [m('span', '✓'), m('h2', 'Жалоба принята'), m('p', `Номер обращения: ${this.reference}. Сведения переданы в штатную очередь модерации DevConnect.`), m('a.Button', {
      href: '/'
    }, 'Вернуться на главную')]);
  }
}
flarum.reg.add('devconnect-content-complaints', 'forum/components/ContentComplaintPage', ContentComplaintPage);